import React from 'react'
import { css } from '@emotion/css'
import {
  CsSendIcon,
  CsTagIcon,
  CsEllipsisIcon
} from '../../../legacy-design-system/icons'

export function DrilldownActions() {
  /* TODO: TS-509, TS-510, TS-511, TS-512, TS-513, TS-514, TS-515, TS-516 */
  return (
    <span
      className={css`
        & > * {
          :not(:last-child) {
            margin-right: 10px;
          }
        }
      `}
    >
      <CsTagIcon />
      <CsSendIcon />
      <CsEllipsisIcon />
    </span>
  )
}
